export interface AllSection {
	SectionId: number;
	SectionName: string;
	LBsPerFoot: number | null;
	Description: string | null;
	IsActive: boolean;
	AssetName: string | null;
}

export const getAllSectionMillNames = (section: AllSection): string[] =>
	section.AssetName?.split(",")
		.map((name) => name.trim())
		.filter((name) => name.length > 0) ?? [];
